<template>
  <a-select
    v-model:value="state.value"
    :mode="props.mode"
    :placeholder="props.placeholder"
    style="width: 100%"
    :disabled="props.disabled"
    show-search
    :filter-option="false"
    :not-found-content="state.fetching ? undefined : null"
    :options="state.data"
    @search="fetchUser"
    @change="changeValue"
  >
    <template v-if="state.fetching" #notFoundContent>
      <a-spin size="small" />
    </template>
  </a-select>
</template>
<script lang="ts" setup>
import { reactive, ref, onMounted, h, watch } from 'vue'
import { debounce } from 'lodash-es'
import baseService from '@/utils/http/axios'
const emit = defineEmits(['update:value', 'change'])
const props = defineProps({
  value: {
    type: [Number, Array],
    default: null
  },
  mode: {
    //multiple 是多选，undefined是单选
    type: String,
    default: undefined
  },
  placeholder: {
    type: String,
    default: '请选择'
  },
  disabled: {
    type: Boolean,
    default: false
  }
})
interface istate {
  data: any[]
  value: any
  fetching: boolean
}
const state = reactive<istate>({
  data: [],
  value: null,
  fetching: false
})
onMounted(() => {
  if (props.mode == 'multiple') {
    if (props.value && Array.isArray(props.value)) {
      state.value = props.value.map(Number)
    } else {
      state.value = []
    }
  } else {
    if (props.value) {
      state.value = Number(props.value)
    } else {
      state.value = null
    }
  }
  if (props.value) {
    // 查询默认的人员
    if (Array.isArray(props.value)) {
      fetchUser('ids=' + props.value.join())
    } else {
      fetchUser('id=' + props.value)
    }
  }
})
//查询用户
let lastFetchId = 0
const fetchUser = debounce((value) => {
  lastFetchId += 1
  const fetchId = lastFetchId
  state.data = []
  state.fetching = true
  let requestParam = {
    url: '/admin/user/publicList',
    method: 'post',
    data: { keyword: value }
  }
  baseService(requestParam).then((body) => {
    if (fetchId !== lastFetchId || body.data.length == 0) {
      return
    }
    state.data = body.data
    state.fetching = false
  })
}, 300)
//改变值
const changeValue = (value: any) => {
  emit('update:value', state.value)
  emit('change', state.value)
}
watch(
  () => props.value,
  (val) => {
    if (val) {
      let oldval = state.value
      if (props.mode == 'multiple') {
        if (props.value && Array.isArray(props.value)) {
          state.value = props.value.map(Number)
        } else {
          state.value = []
        }
      } else {
        if (props.value) {
          state.value = Number(props.value)
        } else {
          state.value = null
        }
      }
      if (props.value && JSON.stringify(oldval) != JSON.stringify(state.value)) {
        // 查询默认的人员
        if (Array.isArray(props.value)) {
          fetchUser('ids=' + props.value.join())
        } else {
          fetchUser('id=' + props.value)
        }
      }
    }
  },
  {
    deep: true,
    immediate: true
  }
)
</script>
